import React from "react";

export default function PageHero({ kicker, title, subtitle }) {
  return (
    <section className="relative pt-40 pb-24 lg:pt-48 lg:pb-32 bg-[#0a0a0a] overflow-hidden">
      <div
        className="absolute inset-0 opacity-[0.06] pointer-events-none"
        style={{
          backgroundImage: "radial-gradient(circle at 1px 1px, #B87333 1px, transparent 0)",
          backgroundSize: "36px 36px"
        }}
      />
      <div
        className="absolute inset-0 opacity-40 pointer-events-none"
        style={{
          background:
            "radial-gradient(ellipse 50% 40% at 80% 10%, rgba(184,115,51,0.18), transparent 60%)"
        }}
      />
      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="flex items-center gap-3 mb-6">
          <span className="divider-line" />
          <span className="text-[11px] tracking-[0.4em] text-[#B87333]">{kicker}</span>
        </div>
        <h1 className="font-serif-display text-[#f5ede1] text-5xl md:text-6xl lg:text-7xl leading-[1.05] font-light max-w-4xl">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-8 text-[#a89a85] text-lg max-w-2xl leading-relaxed">{subtitle}</p>
        )}
      </div>
    </section>
  );
}
